var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "calendar-stub text-body-1" }, [
    _vm._v(
      "\n  " + _vm._s(_setup.t("Запись недоступна", _setup.options)) + "\n"
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }